import React from 'react';
import {isAfter, isBefore, isValid, parseISO} from 'date-fns';

const BOLD_MARKER_REGEX = /\*\*([^*]+)\*\*/g;

function parseConfigDate(value, fieldName, required = false) {
    if (!value) {
        if (required) {
            console.warn(`Promo config is missing required "${fieldName}" date.`);
        }
        return null;
    }

    const parsedDate = typeof value === 'string' ? parseISO(value) : new Date(value);
    if (!isValid(parsedDate)) {
        console.warn(`Promo config has an invalid "${fieldName}" date: ${value}`);
        return null;
    }

    return parsedDate;
}

export function isPromoActive(config, now = new Date()) {
    if (!config) return false;

    const expireDate = parseConfigDate(config.expire, 'expire', true);
    if (!expireDate) return false;

    const startDate = parseConfigDate(config.start, 'start');
    if (startDate && isBefore(now, startDate)) return false;

    return !isAfter(now, expireDate);
}

export function renderPromoMessage(message) {
    if (!message) return null;

    const parts = [];
    let lastIndex = 0;
    let match;

    BOLD_MARKER_REGEX.lastIndex = 0;
    while ((match = BOLD_MARKER_REGEX.exec(message)) !== null) {
        if (match.index > lastIndex) {
            parts.push(message.slice(lastIndex, match.index));
        }

        parts.push(React.createElement('strong', {key: `bold-${match.index}`}, match[1]));
        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < message.length) {
        parts.push(message.slice(lastIndex));
    }

    return parts.length === 1 ? parts[0] : parts;
}
